export const SET_EMPLOYER_INFO = "SET_EMPLOYER_INFO";

export const setEmployerInfo = employerInfo => ({
  type: SET_EMPLOYER_INFO,
  payload: employerInfo
});
